import { CategoryEnum } from '@ingenico/react-configuration-generator';
import { toString } from 'lodash-es';

const validConfigurationCategories = new Set<string>(Object.values(CategoryEnum));

function parseConfigurationCategory(rawCategory: string | null): CategoryEnum | undefined {
  const trimmedCategory = rawCategory?.trim();
  return trimmedCategory && validConfigurationCategories.has(trimmedCategory)
    ? (trimmedCategory as CategoryEnum)
    : undefined;
}

export function getConfigurationTabParams(searchParams: URLSearchParams): {
  readonly category?: CategoryEnum;
  readonly applicationId: string;
} {
  return {
    category: parseConfigurationCategory(searchParams.get('category')),
    applicationId: toString(searchParams.get('applicationId')),
  };
}
